// eslint-disable-next-line no-unused-vars
import * as navigation from './navigation';
import headerTransform from './header-transform';
import classToggles from './class-toggles';
import legacyDocs from './legacy-docs';
import showPricingTable from './price-table-link';
import testimonialLoader from './testimonial-loader';
import copyKeyText from './copy-key-text';
import accordionBlock from './accordian';
import modalPopup from './modals';
import moreBlock from './more-block';
import slider from './slider';
import bigCardSlider from './single-big-card-slider';
import pricing from './pricing';
import config from './config';
import cta from './cta';
import shopifyPricing from './shopify-pricing';
import partnerTrialPage from './partner-trial';
import pricingIndustries from './pricing-industries';
import cartBanner from './cart-banner';

headerTransform();
classToggles();
legacyDocs();
showPricingTable();
pricingIndustries();
testimonialLoader();
copyKeyText();
accordionBlock();
modalPopup();
moreBlock();
slider();
bigCardSlider();
pricing();
config();
cta();
shopifyPricing();
partnerTrialPage();
cartBanner.init();
